import { Card, CardBody, Input, Button, ButtonGroup, Tooltip, Stack, Textarea, VStack, HStack, Divider, Box, Flex } from '@chakra-ui/react'
import React, { useState, useContext } from 'react'
import { api } from '../../../apis/configs/axiosConfigs'
import { CountingTabsContext } from '../CountingTabs/CountingTabs'
import { useSearchParams } from 'react-router-dom'
import { useParams } from 'react-router-dom'  
import useForm from 'hooks/useForm/useForm' 
import useAuthStore from 'stores/authStore'

import { Signature } from './Signature'
import Galery  from './Galery'

// const getResults = async function (params) {
//     const response = await api.request({
//         url: 'counting/inventory-results/' + params.countingId,
//     })

//     return response.data.results
// }

const forRevise = [
    {
        name: 'Counted Items',
        path: 'counted-items',
    },
    {
        name: 'Counted Rows',
        path: 'counted-rows',
    },
    {
        name: 'Counted Category Free',
        path: 'category-free',
    },
    // {
    //     name: 'Plan/Actual',
    //     path: 'plan-actual',
    // },
    // {
    //     name: 'Items Edited',
    //     path: 'items-edited',
    // },
    {
        name: 'Items Invalid',
        path: 'invalid-items',
    },
    {
        name: 'Rows Double',
        path: 'double-rows',
    },
    {
        name: 'Rows Missed',
        path: 'missed-rows',
    },
    // {
    //     name: 'Rows Empty',
    //     path: 'rows-empty',
    // },
    {
        name: 'Counting Hours',
        path: 'counting-hours',
    },
]

export const InventoryResults = () => {
    
    const { revisedTabs, counting, refreshCounting, updateCounting, setCounting } = useContext(CountingTabsContext)
    const keyFields = [
        'time_start_manually',
        'time_finish_manually',
        'items_amount_manually',
        'items_no_barcode_manually',
        'store_prepared',
        'notes',
        'manager_name_manually',
        'manager_signature_manually'
    ]
  
    const handleChangeExtra = (event) => {
        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value
        setCounting(prevState => ({...prevState, [event.target.name]: value}))
    }

    const [searchParams, setSearchParams] = useSearchParams()
    const { countingId } = useParams()

    const notRevisedTabs = forRevise.filter(item => !revisedTabs.includes(item.path))

    const [managerSignature, setManagerSignature] = useState(counting?.manager_signature)

    const user = useAuthStore((state) => state.user)

    // const snakeToCamel = str =>
    //     str.toLowerCase().replace(/([-_][a-z])/g, group =>
    //         group
    //         .toUpperCase()
    //         .replace('-', '')
    //         .replace('_', '')
    //     )

    return (
        <>
            <Card>
                <CardBody style={{ direction: 'rtl', marginBottom: '5px'}}>
                        <Flex
                            direction={{ base: 'column', lg: 'row' }}
                            align={{ base: 'stretch', lg: 'flex-start' }}
                            /*gap={{ base: '6', lg: '10vw' }}*/
                            w='100%'
                            dir='ltr'
                            justifyContent={{ base: 'flex-start', lg: 'space-between' }}
                            >
                        <Stack spacing={6} maxWidth={'550'} dir='rtl' order={{ base: 1, lg: 2 }}>
                            <div>שם חברה: <strong>{counting.store?.company?.name}</strong></div>
                            <div>שם סניף: <strong>{counting.store?.name} {counting.store?.code}</strong></div>
                            <div>תאריך תחילת ספירה: <strong>{(new Date(counting.date_start)).toLocaleDateString('he-IL')}</strong></div>
                            <div>שעת תחילת ספירה: </div>
                                <Input type='time' value={counting.time_start_manually} onChange={handleChangeExtra} name='time_start_manually' form='getPdf' htmlSize={30} width='auto' borderColor='green' placeholder='*חובה להקליד'/>
                            <div>תאריך סיום ספירה: 
                                {!user.is_admin && <strong > {!!counting.time_finish_manually && (new Date(counting.time_finish_manually)).toLocaleDateString('he-IL')}</strong>}
                            </div>
                            {!user.is_admin && <Tooltip placement='top' label='בלחיצה על כפתור סיום ספירה בטופס זה, שעת סיום הספירה תופיע פה'>
                                <div > שעת סיום ספירה: <strong> {!!counting.time_finish_manually && (new Date(counting.time_finish_manually)).toLocaleTimeString('he-IL')}</strong></div>
                            </Tooltip>}
                            
                            <Input hidden={!user.is_admin} type='datetime-local' value={counting.time_finish_manually ?? '' } onChange={handleChangeExtra} name='time_finish_manually' form='getPdf' width='auto' borderColor='green' />
                            <Tooltip placement='top' label='יימשך משייוך הספירה למנהל ספירה'>
                                <div>מנהל ספירה : <strong> {!!counting.manager && `${counting.manager.name} ${counting.manager.last_name}`}</strong> </div>
                            </Tooltip>
                            <div>כמות פריטים שנספרה: 
                                </div><Input type='number' value={counting.items_amount_manually} name='items_amount_manually' form='getPdf' onChange={handleChangeExtra} htmlSize={30} width='auto' borderColor='green' placeholder='*חובה להקליד תאריך'/>
                            <div>פריטים ללא ברקוד: 
                                </div> <Input value={ counting.items_no_barcode_manually } name='items_no_barcode_manually' form='getPdf'  dir='rtl' onChange={handleChangeExtra} htmlSize={30} width='auto' borderColor='green' placeholder='למילוי ידנית'/>
                            <div>אישור מנהל/ת החנות את נכונות תוצאות הספירה:</div>
                            <div>שם: </div><Input value={counting.manager_name_manually} name='manager_name_manually'  form='getPdf' dir='rtl' onChange={handleChangeExtra} htmlSize={30} width='auto' borderColor='green' placeholder='חובה להקליד*'/>
                            <div>חתימה: </div> 
                            <Signature 
                                signature={managerSignature} 
                                setSignature={setManagerSignature} 
                                name='manager_signature' 
                                setCounting={data => setCounting(prevState => ({...prevState, ...data}))}
                                />
                            <ButtonGroup spacing={6} >
                                <Button colorScheme='green' isDisabled={notRevisedTabs.length} hidden={!!counting.time_finish_manually} onClick={
                                    ()=> {
                                        const date = new Date()
                                        const time_finish_manually = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().slice(0,16)
                                        setCounting(prevState => ({...prevState, time_finish_manually})) 
                                    }}>סיום ספירה
                                </Button>
                                <form id='getPdf' method='get' action={`${process.env.REACT_APP_API_BASE_URL}/counting/summary/${counting._id}`} target='_blank'>
                                    <Button type='submit' colorScheme='yellow'>הורדה</Button>
                                </form>

                            </ButtonGroup>
                        </Stack>
                        {/* <Divider orientation='vertical' width='sm'/> */}
                        <VStack spacing='40px' 
                                align='stretch'
                                w={{ base: '100%', lg: '550px' }}
                                //flexShrink={0}
                                order={{ base: 2, lg: 1 }}>
                            <Galery countingId={countingId} />                  
                           
                            <VStack justifyContent='flex-end' 
                            height='100%' align='right' 
                            spacing='6px' hidden={!!counting.time_finish_manually}>
                                <h1>לשוניות שלא סגורים:</h1>                         
                                {
                                    notRevisedTabs
                                        .map((tab, idx) => (
                                            <Button key={idx} onClick={() => setSearchParams({tab: tab.path})} 
                                                variant='outline' 
                                                colorScheme='yellow'>
                                                    {tab.name}
                                            </Button>)
                                        )
                                }
                            </VStack>
                        </VStack>
                        </Flex>
                </CardBody>
            </Card>
        </>
    )
}